import React, { useState, useEffect } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { AES, enc } from "crypto-js";
import { BASE_URL } from "../CommonApi";
import { FiEdit2, FiCreditCard, FiHash, FiDollarSign } from "react-icons/fi";
import { BsBank2, BsBuilding } from "react-icons/bs";
import BankAccNew from "./BankAccNew";
import "./BankDetails.css";

function BankDetails(props) {
  const handleCancleClick = () => {
    const confirmCancel = window.confirm("Are you sure Leave this page?");
    if (confirmCancel) {
      props.handleCancle();
    } else {
      console.log("Cancellation not confirmed");
    }
  };

  const { id, navigation } = props;
  const [itemId1, setItemId1] = useState(id);
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  const decryptedUniqueId = AES.decrypt(
    encryptedUniqueId,
    "1234567812345678"
  ).toString(enc.Utf8);
  const [showDetails, setShowDetails] = useState(true);
  const [showEditPage, setEditPage] = useState(false);
  const jwtToken = localStorage.getItem("jwtToken");

  const handleEditOpen = (id) => {
    // Navigate to BankAccNew with the bank ID for editing
    setShowDetails(false);
    setEditPage(true);
  };

  const handleCancel = () => {
    setEditPage(false);
    setShowDetails(true);
  };

  const [itemData, setItemData] = useState({});

  // Overview
  useEffect(() => {
    const apiUrl = BASE_URL + `/getBankById/${itemId1}`;
    fetch(apiUrl, {
      method: "Post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({ uniqueId: decryptedUniqueId }),
    })
      .then((response) => response.json())
      .then((data) => {
        setItemData(data.responseMessage);
      })
      .catch((error) => console.error("Error fetching overview data:", error));
  }, [itemId1]);

  return (
    <>
      {showDetails && (
        <div className="bank-details-wrapper">
          {/* Header Section */}
          <div className="bank-details-header">
            <div className="bank-details-header-left">
              <button className="bank-back-button" onClick={handleCancleClick}>
                <ArrowBackIosIcon style={{ fontSize: 18 }} />
              </button>
              <div className="bank-header-text">
                <h1>Bank Account Details</h1>
                <p>View bank account information</p>
              </div>
            </div>
            <div className="bank-details-header-right">
              <button className="btn-edit-bank" onClick={() => handleEditOpen(itemData.id)}>
                <FiEdit2 size={16} />
                <span>Edit Bank</span>
              </button>
            </div>
          </div>

          {/* Summary Card */}
          <div className="bank-summary-card">
            <h2 className="bank-summary-name">{itemData.bankName || "Bank Name"}</h2>
            <p className="bank-summary-account">{itemData.name || "Account Name"}</p>
            <span className="bank-type-badge">
              <BsBank2 style={{ marginRight: 6, fontSize: 14 }} />
              Bank
            </span>
          </div>

          {/* Details Card */}
          <div className="bank-details-card">
            <div className="bank-details-grid">
              {/* Left Column */}
              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <BsBank2 className="detail-icon" />
                  Bank Type
                </div>
                <div className={`bank-detail-value ${!itemData.accountType ? 'empty' : ''}`}>
                  {itemData.accountType || "Not Available"}
                </div>
              </div>

              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <FiCreditCard className="detail-icon" />
                  Account Number
                </div>
                <div className={`bank-detail-value ${!itemData.accountNumber ? 'empty' : ''}`}>
                  {itemData.accountNumber || "Not Available"}
                </div>
              </div>

              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <BsBank2 className="detail-icon" />
                  Account Name
                </div>
                <div className={`bank-detail-value ${!itemData.name ? 'empty' : ''}`}>
                  {itemData.name || "Not Available"}
                </div>
              </div>

              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <FiHash className="detail-icon" />
                  IFSC Code
                </div>
                <div className={`bank-detail-value ${!itemData.ifsc ? 'empty' : ''}`}>
                  {itemData.ifsc || "Not Available"}
                </div>
              </div>

              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <FiHash className="detail-icon" />
                  Account Code
                </div>
                <div className={`bank-detail-value ${!itemData.accountCode ? 'empty' : ''}`}>
                  {itemData.accountCode || "Not Available"}
                </div>
              </div>

              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <BsBuilding className="detail-icon" />
                  Branch Name
                </div>
                <div className={`bank-detail-value ${!itemData.branchName ? 'empty' : ''}`}>
                  {itemData.branchName || "Not Available"}
                </div>
              </div>

              <div className="bank-detail-item">
                <div className="bank-detail-label">
                  <FiDollarSign className="detail-icon" />
                  Currency
                </div>
                <div className={`bank-detail-value ${!itemData.currency ? 'empty' : ''}`}>
                  {itemData.currency || "Not Available"}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showEditPage && <BankAccNew navigation={navigation} id={itemData.id} handleCancle={handleCancel} />}
    </>
  );
}

export default BankDetails;
